export const analyticsEvents = {
  ads_clicked: 'ads_clicked',
  ads_viewed: 'ads_viewed',
  collection_clicked: 'collection_clicked',
  collection_empty_viewed: 'collection_empty_viewed',
  collection_error_viewed: 'collection_error_viewed',
  collection_event_clicked: 'collection_event_clicked',
  collection_filter_applied: 'collection_filter_applied',
  collection_viewed: 'collection_viewed',
  event_add_calendar_clicked: 'event_add_calendar_clicked',
  event_share_clicked: 'event_share_clicked',
  faq_clicked: 'faq_clicked',
  faq_viewed: 'faq_viewed',
  footer_menu_clicked: 'footer_menu_clicked',
  header_clicked: 'header_clicked',
  header_is_producer_bar_clicked: 'header_is_producer_bar_clicked',
  home_highlight_events_clicked: 'home_highlight_events_clicked',
  sports_highlight_events_clicked: 'sports_highlight_events_clicked',
  home_viewed: 'home_viewed',
  menu_option_clicked: 'menu_option_clicked',
  order_payment_processing_viewed: 'order_payment_processing_viewed',
  page_view_more_clicked: 'page_view_more_clicked',
  page_view_more_event_clicked: 'page_view_more_event_clicked',
  page_view_more_filter_applied: 'page_view_more_filter_applied',
  page_view_more_viewed: 'page_view_more_viewed',
  rail_event_clicked: 'rail_event_clicked',
  rail_event_viewed: 'rail_event_viewed',
  rail_view_more_clicked: 'rail_view_more_clicked',
  search_recommended_clicked: 'search_recommended_clicked',
  search_recommended_event_clicked: 'search_recommended_event_clicked',
  search_results_viewed: 'search_results_viewed',
  search_result_clicked: 'search_result_clicked',
  search_submitted: 'search_submitted',
  search_started: 'search_started',
  collection_search_submitted: 'collection_search_submitted',
  sympla_for_producers_viewed: 'sympla_for_producers_viewed',
  sympla_for_producers_clicked: 'sympla_for_producers_clicked'
} as const;

export const analyticsLabels = {
  conclusionPage: 'Página de conclusão de compra',
  homePage: 'Home',
  reclameAqui: 'Reclame Aqui',
  trendingEvents: 'Eventos em alta',
  recommendedEvents: 'Eventos recomendados',
  top10Events: 'Eventos Top 10',
  pageWithNoResults: 'Página sem resultados',
  lastCallEvents: 'Última chamada',
  favorites: 'Favoritos',
  externalPage: 'Página externa',
  sports: 'Sports',
  featuredSportsCategories: 'Categorias esportivas em destaque'
} as const;

export const transportMethods = {
  sendBeacon: 'sendBeacon',
  xhr: 'xhr'
} as const;
